"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8814],{

/***/ 3393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FeaturedEditorialCategory; },
  "E": function() { return /* binding */ editorialCategoryProps; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/assets/svg/CTUP_logo.svg
var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function SvgCtupLogo(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 114,
    height: 32,
    viewBox: "0 0 114 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#CTUP_logo_svg__clip0_1521_893)",
    fill: "#fff"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M105.431.003H92.427a.533.533 0 00-.347.12.733.733 0 00-.243.417L91.11 6.4h12.554c1.426 0 2.53 1.24 2.357 2.643l-.353 2.833a2.369 2.369 0 01-2.357 2.067H90.176l-2.092 16.894c-.03.15 0 .277.09.38.092.106.21.157.363.157h6.234c.125 0 .25-.04.344-.12a.75.75 0 00.243-.417l1.311-10.8c.06-.148.149-.224.27-.224h7.823c3.801 0 7.025-2.778 7.551-6.513l.663-4.68c.645-4.552-2.92-8.615-7.551-8.615l.006-.003zM36.959 10.927a.59.59 0 00-.588.516l-2.39 19.395c-.03.151 0 .278.091.38a.45.45 0 00.362.157h6.235c.124 0 .252-.039.347-.12a.728.728 0 00.24-.417l2.372-19.253a.588.588 0 00-.587-.658h-6.082zM29.37 6.41a.45.45 0 01-.361-.157.421.421 0 01-.091-.38L29.55.539a.707.707 0 01.204-.38.523.523 0 01.383-.157h22.815c.15 0 .271.051.362.157a.43.43 0 01.092.38l-.679 5.334c0 .15-.06.278-.18.38a.601.601 0 01-.407.157H29.368h.003zM55.07 25.39a8.262 8.262 0 002.394 3.789c1.882 1.704 4.419 2.555 7.612 2.555h6.082c2.32 0 4.413-.456 6.28-1.367 1.868-.91 3.388-2.202 4.562-3.876 1.174-1.675 1.898-3.6 2.169-5.784L86.699.54c.03-.151 0-.278-.091-.38a.45.45 0 00-.362-.157H80.01a.514.514 0 00-.383.157.751.751 0 00-.204.38l-2.53 20.167c-.152 1.406-.684 2.531-1.603 3.385-.918.851-2.025 1.298-3.32 1.298H55.066h.003z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M55.387 20.883h6.07a.59.59 0 00.588-.516l2.49-19.83c.03-.15 0-.278-.09-.38A.451.451 0 0064.081 0h-6.234a.533.533 0 00-.347.12.733.733 0 00-.243.417l-2.46 19.685a.59.59 0 00.586.66h.003zM24.768.003c.456 0 .809.398.751.85l-.617 4.879a.756.756 0 01-.751.658H11.636a2.748 2.748 0 00-2.734 2.392l-1.67 13.199c-.206 1.632 1.077 3.074 2.734 3.074h11.63c.456 0 .81.398.751.85l-.617 4.879a.756.756 0 01-.751.658H6.235c-3.75 0-6.651-3.262-6.186-6.951L2.446 5.467C2.835 2.38 5.475.06 8.613.048L24.768 0v.003z"
  }))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "CTUP_logo_svg__clip0_1521_893"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h113.333v32H0z"
  })))));
}
/* harmony default export */ var CTUP_logo = (SvgCtupLogo);
;// CONCATENATED MODULE: ./src/assets/svg/CTEletroGreen.svg
var CTEletroGreen_g, CTEletroGreen_defs;
var CTEletroGreen_excluded = ["title", "titleId"];
function CTEletroGreen_extends() { CTEletroGreen_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return CTEletroGreen_extends.apply(this, arguments); }
function CTEletroGreen_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = CTEletroGreen_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function CTEletroGreen_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function SvgCtEletroGreen(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = CTEletroGreen_objectWithoutProperties(_ref, CTEletroGreen_excluded);
  return /*#__PURE__*/react.createElement("svg", CTEletroGreen_extends({
    width: 155,
    height: 32,
    viewBox: "0 0 155 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, CTEletroGreen_g || (CTEletroGreen_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#CTEletroGreen_svg__clip0_1521_919)",
    fill: "#2EC900"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M24.759.355H4.294a.576.576 0 00-.4.158.49.49 0 00-.18.377L.013 30.977c-.03.15 0 .275.088.377.088.103.21.158.356.158h20.465a.508.508 0 00.378-.158.759.759 0 00.202-.377l.625-5.252a.426.426 0 00-.089-.378.452.452 0 00-.356-.157H8.083c-.118 0-.18-.074-.18-.224l.712-5.875c.06-.147.147-.224.268-.224h8.695a.508.508 0 00.378-.157.73.73 0 00.202-.378l.624-5.208a.426.426 0 00-.088-.377.452.452 0 00-.357-.158H9.643c-.117 0-.18-.073-.18-.223l.669-5.476c0-.147.088-.224.268-.224h13.555a.508.508 0 00.378-.157.759.759 0 00.202-.378L25.203.88a.426.426 0 00-.088-.377.452.452 0 00-.356-.158v.011zM47.451 25.189H33.628c-.118 0-.18-.073-.18-.224L36.44.89c0-.355-.165-.535-.492-.535h-6.11a.576.576 0 00-.4.158.49.49 0 00-.18.377l-3.7 30.087c-.03.15 0 .275.088.378.088.102.21.157.356.157h20.645a.583.583 0 00.4-.157.672.672 0 00.224-.378l.624-5.252a.426.426 0 00-.088-.378.452.452 0 00-.356-.157zM75.278.355H54.813a.576.576 0 00-.4.158.49.49 0 00-.18.377l-3.7 30.087c-.03.15 0 .275.088.377.088.103.209.158.356.158h20.465a.508.508 0 00.378-.158.758.758 0 00.202-.377l.624-5.252a.426.426 0 00-.088-.378.452.452 0 00-.356-.157h-13.6c-.117 0-.18-.074-.18-.224l.713-5.875c.059-.147.147-.224.268-.224h8.694a.508.508 0 00.378-.157.759.759 0 00.202-.378l.624-5.208a.426.426 0 00-.088-.377.452.452 0 00-.356-.158h-8.694c-.118 0-.18-.073-.18-.223l.668-5.476c0-.147.088-.224.268-.224h13.556a.508.508 0 00.378-.157.759.759 0 00.202-.378L75.723.88a.426.426 0 00-.088-.377.452.452 0 00-.357-.158v.011zM102.072.512a.451.451 0 00-.356-.158H79.199a.502.502 0 00-.379.158.73.73 0 00-.201.377l-.625 5.296c-.029.15 0 .275.088.378.089.102.21.157.357.157h7.313c.118 0 .18.074.18.224l-2.94 24.036c-.03.15 0 .275.087.377.089.103.21.158.357.158h6.153a.508.508 0 00.378-.158.759.759 0 00.202-.377L93.11 6.944c0-.147.088-.224.268-.224h7.534a.581.581 0 00.4-.157.488.488 0 00.18-.378L102.16.89a.424.424 0 00-.088-.377zM118.866.355h-12.84a.578.578 0 00-.4.158.491.491 0 00-.18.377l-3.701 30.087c-.029.15 0 .275.089.378a.451.451 0 00.356.157h6.153a.508.508 0 00.378-.157.757.757 0 00.202-.378l1.428-11.662c0-.147.074-.224.224-.224h2.853c.118 0 .209.059.268.18l3.613 11.838c.088.268.283.4.58.4h6.466c.356 0 .536-.132.536-.4a.522.522 0 00-.044-.224l-4.193-12.24c-.059-.148-.015-.254.132-.313 1.784-.652 3.238-1.704 4.369-3.159 1.131-1.455 1.828-3.174 2.096-5.164.059-.652.089-1.129.089-1.426 0-2.521-.757-4.522-2.273-6.007-1.516-1.484-3.584-2.224-6.198-2.224l-.003.003zm.11 12.018c-.756.711-1.718 1.067-2.875 1.067h-4.817c-.18 0-.239-.074-.18-.224l.756-6.319c0-.146.089-.223.268-.223h4.77c.98 0 1.762.26 2.342.777.58.52.87 1.224.87 2.115 0 1.158-.378 2.092-1.138 2.803l.004.004zM152.916 4.607c-.848-1.47-2.059-2.602-3.634-3.405C147.706.4 145.849 0 143.708 0c-2.32 0-4.42.484-6.307 1.448a12.475 12.475 0 00-4.638 4.05c-1.204 1.737-1.938 3.73-2.206 5.985l-1.116 8.902c-.059.418-.088.993-.088 1.737 0 3.028.936 5.432 2.808 7.21 1.873 1.781 4.413 2.672 7.626 2.672 2.346 0 4.472-.484 6.377-1.448a12.332 12.332 0 004.66-4.072c1.204-1.752 1.938-3.782 2.206-6.099l1.069-8.902c.058-.385.088-.964.088-1.738 0-1.957-.423-3.672-1.271-5.142v.004zm-7.39 2.225c.532 0 .91.432.848.964l-.518 4.292h-1.928l.518-4.292a1.118 1.118 0 011.08-.964zm-5.141 0c.533 0 .911.432.849.964l-.518 4.292h-1.928l.518-4.292a1.117 1.117 0 011.079-.964zm1.822 18.336h-2.93c-2.442 0-4.186-1.975-3.888-4.412l.815-6.752h11.774l-.815 6.752c-.294 2.437-2.511 4.412-4.956 4.412z"
  }))), CTEletroGreen_defs || (CTEletroGreen_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "CTEletroGreen_svg__clip0_1521_919"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h154.182v32H0z"
  })))));
}
/* harmony default export */ var CTEletroGreen = (SvgCtEletroGreen);
;// CONCATENATED MODULE: ./src/assets/svg/AutoWhite.svg
var AutoWhite_g, AutoWhite_defs;
var AutoWhite_excluded = ["title", "titleId"];
function AutoWhite_extends() { AutoWhite_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return AutoWhite_extends.apply(this, arguments); }
function AutoWhite_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = AutoWhite_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function AutoWhite_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function SvgAutoWhite(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = AutoWhite_objectWithoutProperties(_ref, AutoWhite_excluded);
  return /*#__PURE__*/react.createElement("svg", AutoWhite_extends({
    width: 135,
    height: 32,
    viewBox: "0 0 135 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, AutoWhite_g || (AutoWhite_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#AutoWhite_svg__clip0_1521_911)",
    fill: "#fff"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M20.138 31.377a.638.638 0 01-.175-.31l-.615-3.962c-.06-.117-.132-.178-.221-.178H9.403c-.09 0-.162.06-.221.178l-1.583 3.961c-.15.298-.367.445-.661.445H.423c-.175 0-.3-.05-.373-.157-.073-.104-.066-.261.023-.468L12.833.8c.146-.297.354-.444.616-.444h8.05c.265 0 .44.15.53.444l5.5 30.088v.177c0 .298-.163.445-.483.445h-6.558a.47.47 0 01-.353-.134h.003zm-8.362-10.146h6.336c.146 0 .222-.09.222-.268l-1.848-11.44c-.03-.117-.073-.17-.132-.157-.06.017-.103.067-.132.157l-4.578 11.44c-.09.178-.043.268.132.268zM33.636 29.331c-1.835-1.691-2.75-3.961-2.75-6.81 0-.357.03-.889.089-1.601L33.441.892a.733.733 0 01.198-.378.509.509 0 01.373-.157h6.072c.145 0 .264.053.353.157.09.103.116.23.09.378L38.06 20.92a4.1 4.1 0 00-.043.712c0 1.187.344 2.136 1.035 2.848.687.712 1.62 1.07 2.793 1.07 1.259 0 2.34-.421 3.232-1.267.896-.846 1.414-1.966 1.563-3.36L49.107.895a.733.733 0 01.198-.378.509.509 0 01.374-.157h6.071c.146 0 .264.054.354.157.089.104.115.23.089.378l-2.466 20.028c-.264 2.167-.968 4.079-2.112 5.74a11.554 11.554 0 01-4.445 3.852c-1.818.906-3.857 1.357-6.118 1.357-3.11 0-5.582-.846-7.413-2.538l-.003-.003zM82.465.512c.09.103.116.23.09.377l-.661 5.296c0 .15-.06.274-.176.378a.591.591 0 01-.396.157h-7.437c-.175 0-.264.073-.264.224l-2.905 24.033a.721.721 0 01-.199.378.51.51 0 01-.373.157h-6.072a.432.432 0 01-.353-.157c-.09-.104-.12-.23-.09-.378l2.906-24.033c0-.147-.06-.224-.175-.224h-7.215a.432.432 0 01-.354-.157.423.423 0 01-.09-.378l.615-5.296a.734.734 0 01.199-.377.509.509 0 01.373-.158h22.22c.146 0 .265.054.354.158h.003zM124.53 3.148H93.65c-3.35 0-6.147 2.541-6.504 5.914l-1.319 12.47a6.666 6.666 0 001.64 5.125 6.516 6.516 0 004.865 2.193h30.88c3.351 0 6.147-2.54 6.504-5.914l1.319-12.47a6.666 6.666 0 00-1.64-5.124 6.516 6.516 0 00-4.865-2.194zm3.728 6.39l-1.606 13.699c-.192 1.648-1.573 2.889-3.216 2.889H91.82c-1.94 0-3.444-1.712-3.216-3.661l1.606-13.7c.195-1.648 1.573-2.889 3.216-2.889h31.617c1.94 0 3.444 1.712 3.215 3.661z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M124.918 0H93.48c-4.726 0-8.71 3.577-9.264 8.324l-1.54 13.129c-.658 5.613 3.675 10.55 9.264 10.55h31.438c4.726 0 8.709-3.577 9.264-8.324l1.54-13.128C134.84 4.938 130.507 0 124.918 0zm6.703 10.534l-1.319 12.47c-.39 3.677-3.437 6.449-7.093 6.449h-30.88a7.117 7.117 0 01-5.304-2.39 7.275 7.275 0 01-1.788-5.59l1.319-12.47c.39-3.677 3.437-6.449 7.093-6.449h30.879c2.02 0 3.953.873 5.305 2.39a7.274 7.274 0 011.788 5.59z"
  }))), AutoWhite_defs || (AutoWhite_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "AutoWhite_svg__clip0_1521_911"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h134.244v32H0z"
  })))));
}
/* harmony default export */ var AutoWhite = (SvgAutoWhite);
// EXTERNAL MODULE: ./src/components/Layout/WrapperContent/index.tsx
var WrapperContent = __webpack_require__(3078);
// EXTERNAL MODULE: ./src/components/Layout/NewsTimeLine/index.tsx
var NewsTimeLine = __webpack_require__(2835);
// EXTERNAL MODULE: ./src/components/Layout/EditorialCategorySponsorBanner/index.tsx
var EditorialCategorySponsorBanner = __webpack_require__(4554);
// EXTERNAL MODULE: ./src/components/Layout/Chip/index.tsx
var Chip = __webpack_require__(2384);
// EXTERNAL MODULE: ./src/styles/designSystemColors.ts
var designSystemColors = __webpack_require__(9642);
// EXTERNAL MODULE: ./src/lib/editorialRoutes.ts
var editorialRoutes = __webpack_require__(9762);
;// CONCATENATED MODULE: ./src/components/Home/FeaturedEditorialCategory/index.tsx











var editorialCategoryProps = {
    ctup: {
        background: designSystemColors/* ctup.ctupBlue */.nv.ctupBlue,
        logo: /*#__PURE__*/ (0,jsx_runtime.jsx)(CTUP_logo, {})
    },
    eletro: {
        background: designSystemColors/* cteletro.cteletroBlack */.wz.cteletroBlack,
        logo: /*#__PURE__*/ (0,jsx_runtime.jsx)(CTEletroGreen, {})
    },
    ctauto: {
        background: designSystemColors/* ctauto.ctautoRed */.xx.ctautoRed,
        logo: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoWhite, {})
    },
    ctnegocios: {
        background: designSystemColors/* mglBlue.mglBlue500 */.Db.mglBlue500,
        logo: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {})
    }
};
function FeaturedEditorialCategory(param) {
    var timeline = param.timeline, variant = param.variant;
    var PropTitle = {
        color: designSystemColors/* mglGray.mglGray50 */.Ce.mglGray50
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperContent/* default */.Z, {
            backgroundColor: editorialCategoryProps[variant].background,
            paddingOnBottom: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EditorialCategorySponsorBanner["default"], {
                    isFeatured: true,
                    variant: variant
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "ml-0 grid grid-cols-1 grid-rows-5 gap-5 [grid-auto-columns:1fr] tablet:grid-cols-2 tablet:grid-rows-3 desktop:grid-cols-3 desktop:grid-rows-2",
                    children: timeline.map(function(n) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsTimeLine/* default */.Z, {
                            news: n,
                            propsTitle: PropTitle,
                            headingTag: "h3"
                        }, n.url);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex [&>a]:mx-auto [&>a]:my-0 ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                        texto: "ver mais conte\xfado",
                        chipSize: "medium",
                        title: "ver mais conte\xfado",
                        borderColor: "white",
                        posIcon: "chevron-right",
                        link: "/".concat((0,editorialRoutes/* publicRouteFor */.r5)(variant), "/"),
                        color: "white",
                        hover: "black"
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 4554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ SponsorBanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_Home_FeaturedEditorialCategory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3393);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9659);
/* harmony import */ var _lib_sponsors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6874);
/* harmony import */ var _lib_editorialRoutes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9762);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2153);







var variants = {
    EditorialCategoryLogoContainer: {
        isInternal: {
            true: "isInternal rounded-t-lg rounded-b-none [&.isInternal]:tablet:pb-6 [&.isInternal]:tablet:pb-6 [&>svg]:w-[108px] [&>a>svg]:w-[108px] [&>svg]:h-[33px] [&>a>svg]:h-[33px] p-4",
            false: ""
        },
        isFeatured: {
            true: "isFeatured [&.isFeatured]:py-4 [&.isFeatured]:px-0",
            false: ""
        },
        backgroundColor: {
            ctup: "bg-[#004BCC]",
            eletro: "bg-[#1C1C1C]",
            ctauto: "bg-[#E0140F]"
        }
    },
    EditorialCategorySponsorContainer: {
        editorialCategory: {
            ctup: "flex flex-col before:block before:text-mglGray50 text-sm before:content-[attr(data-before)]",
            eletro: "flex flex-col before:block before:text-mglGray50 text-sm before:content-[attr(data-before)]"
        }
    }
};
var SponsorContainer = function(param) {
    var editorialCategory = param.editorialCategory;
    var responsiveLogoClass = "first:[&>figure]:block";
    var options = {
        ctup: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            "data-before": "Conte\xfado apoiado por:",
            className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("flex", variants.EditorialCategorySponsorContainer.editorialCategory.ctup),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-2 flex justify-center gap-4",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("z-[2] flex items-center", responsiveLogoClass),
                    href: "https://canalte.ch/tcl",
                    rel: "sponsored",
                    title: "Ir para o site da TCL",
                    target: "_blank",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        src: "https://t.ctcdn.com.br/7z5J3EB8Py_zsjQkllq9sPl826k=/i1126385.png",
                        blurhash: "LVT8zXs:cYt7xaV@WVWVqFWVQ-WB",
                        alt: "TCL",
                        height: 39,
                        width: 64,
                        rounded: false
                    })
                })
            })
        }),
        eletro: null,
        ctauto: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "z-[2] flex items-center first:block first:h-8 first:w-8 last:hidden last:h-[30px] last:w-[88px] tablet:block first:tablet:hidden"
        })
    };
    return options[editorialCategory];
};
function SponsorBanner(param) {
    var _isInternal = param.isInternal, isInternal = _isInternal === void 0 ? undefined : _isInternal, _isFeatured = param.isFeatured, isFeatured = _isFeatured === void 0 ? undefined : _isFeatured, variant = param.variant, _isAdvertorial = param.isAdvertorial, isAdvertorial = _isAdvertorial === void 0 ? false : _isAdvertorial;
    var ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var hasLogo = !!((ref = _components_Home_FeaturedEditorialCategory__WEBPACK_IMPORTED_MODULE_2__/* .editorialCategoryProps */ .E[variant]) === null || ref === void 0 ? void 0 : ref.logo);
    var EditorialCategoryLogo = function() {
        // Na própria página da editoria o logo não vira link (o usuário já está lá).
        // Normaliza o slug da URL atual para variant — cobre o slug público (ct-eletro)
        // e os aliases, em vez de comparar o slug cru contra os nomes de variant.
        var currentSlug = Array.isArray(router.query.categorias) ? router.query.categorias[0] : router.query.categorias;
        if (currentSlug && (0,_lib_sponsors__WEBPACK_IMPORTED_MODULE_3__/* .getEditorialCategory */ .PV)(currentSlug) === variant) {
            var ref;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: (ref = _components_Home_FeaturedEditorialCategory__WEBPACK_IMPORTED_MODULE_2__/* .editorialCategoryProps */ .E[variant]) === null || ref === void 0 ? void 0 : ref.logo
            });
        }
        if (hasLogo) {
            var ref1;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: "/".concat((0,_lib_editorialRoutes__WEBPACK_IMPORTED_MODULE_4__/* .publicRouteFor */ .r5)(variant), "/"),
                children: (ref1 = _components_Home_FeaturedEditorialCategory__WEBPACK_IMPORTED_MODULE_2__/* .editorialCategoryProps */ .E[variant]) === null || ref1 === void 0 ? void 0 : ref1.logo
            });
        }
        return null;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("flex flex-col items-center justify-center gap-4 px-6 py-4 tablet:flex-row tablet:justify-between tablet:pb-12 [&>a]:h-8 [&>svg]:h-8", isFeatured && variants.EditorialCategoryLogoContainer.isFeatured[isFeatured.toString()], isInternal && variants.EditorialCategoryLogoContainer.isInternal[isInternal.toString()], variants.EditorialCategoryLogoContainer.backgroundColor[variant]),
        children: [
            hasLogo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EditorialCategoryLogo, {}),
            !isAdvertorial && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SponsorContainer, {
                editorialCategory: variant
            })
        ]
    });
}


/***/ }),

/***/ 9762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jx": function() { return /* binding */ findEditorialByExactVariantSlug; },
/* harmony export */   "r5": function() { return /* binding */ publicRouteFor; }
/* harmony export */ });
/* unused harmony exports EDITORIAL_ROUTES, findEditorialByVariant, findEditorialByPublicSlug, LEGACY_EDITORIA_SLUGS, monolithSlugFor, hasMonolithOverride */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9815);
// Fonte única do contrato de roteamento das editorias (CT UP, CT Eletro, CT Auto).
// Antes destes dados estarem centralizados, o mapeamento slug→rota vivia espalhado
// em quatro pontos (LEGACY_EDITORIA_SLUGS e MONOLITH_SLUG_OVERRIDES na página de
// categorias, EDITORIAL_PUBLIC_ROUTE e o campo `route` no FeaturedEditorialCategory),
// com risco de divergência entre SSR, render e navegação. Tudo que descreve "qual
// slug público, qual slug do monolito e como o bloco da home é buscado" nasce aqui.
//
// Fronteira: este módulo cuida só de slug/rota (dados puros, sem React). Cor e logo
// (apresentação) permanecem em `editorialCategoryProps` no FeaturedEditorialCategory.
// Variant de tema — identifica a editoria para cor, logo e regras de rota.

var EDITORIAL_ROUTES = [
    {
        variant: "ctup",
        slugPublic: "ctup",
        slugMonolith: "ctup",
        slugAliases: [],
        routeType: "id",
        homeRoute: "155778?merge=155790,155842"
    },
    {
        variant: "eletro",
        slugPublic: "ct-eletro",
        slugMonolith: "eletro",
        slugAliases: [
            "cteletro"
        ],
        routeType: "categoria",
        homeRoute: "eletro"
    },
    {
        variant: "ctauto",
        slugPublic: "ctauto",
        slugMonolith: "ctauto",
        slugAliases: [],
        routeType: "categoria",
        homeRoute: "ctauto"
    }, 
];
// Busca a editoria pelo variant de tema.
var findEditorialByVariant = function(variant) {
    return EDITORIAL_ROUTES.find(function(route) {
        return route.variant === variant;
    });
};
// Busca a editoria por um slug de entrada (URL pública ou alias legado).
var findEditorialByPublicSlug = function(slug) {
    return EDITORIAL_ROUTES.find(function(route) {
        return route.slugPublic === slug || route.slugAliases.includes(slug);
    });
};
// Busca a editoria quando o slug bruto coincide exatamente com o nome do variant
// (ctup/eletro/ctauto). Preserva o comportamento histórico da página de categorias,
// que só tratava esses três slugs como editoria de tema — sem capturar categorias
// legadas do CT UP como `hardware`/`games`.
var findEditorialByExactVariantSlug = function(slug) {
    return EDITORIAL_ROUTES.find(function(route) {
        return route.variant === slug;
    });
};
// Slugs de entrada que devem rotear direto para a editoria (merge monolito + Directus):
// os slugs públicos + aliases legados. Note que o slug do monolito (`eletro`) fica de
// fora de propósito — /eletro/ continua sendo categoria pura.
var LEGACY_EDITORIA_SLUGS = EDITORIAL_ROUTES.flatMap(function(route) {
    return [
        route.slugPublic
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(route.slugAliases));
});
var ref;
// Traduz um slug público do Fawkes para o slug que o monolito conhece.
// Retorna o próprio slug quando não há tradução (categoria comum).
var monolithSlugFor = function(slug) {
    var ref1;
    return (ref = (ref1 = findEditorialByPublicSlug(slug)) === null || ref1 === void 0 ? void 0 : ref1.slugMonolith) !== null && ref !== void 0 ? ref : slug;
};
// Indica se o slug público difere do slug do monolito (ex.: ct-eletro → eletro).
var hasMonolithOverride = function(slug) {
    var route = findEditorialByPublicSlug(slug);
    return Boolean(route && route.slugMonolith !== slug);
};
// URL pública (/ctup/, /ct-eletro/, /ctauto/) a partir do variant de tema.
var publicRouteFor = function(variant) {
    return findEditorialByVariant(variant).slugPublic;
};


/***/ })

}]);